import type { RefetchKey } from '../hooks/data/refetchAndCache';

/**
 * The canonical full set of cache keys a global "Refresh" must refetch. Kept as
 * a single exported constant (instead of an inline list at each call site) so
 * the notes keys can never again be silently dropped from a refresh — the exact
 * bug this set guards against. `satisfies` ties it to the `RefetchKey` union so
 * a typo or a removed key is a compile error.
 */
export const ALL_REFETCH_KEYS = [
  'categories',
  'bookmarks',
  'note_categories',
  'notes',
  'note_templates',
] as const satisfies readonly RefetchKey[];
